// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3S71P","header":"MergedInvoice_header__2nmJL"};